export const DEFAULT_TOKEN_LIST_URL = 'MSC'
export const MSC_TOKEN_LIST_URL = 'MSC'

export const DEFAULT_LIST_OF_LISTS: string[] = [MSC_TOKEN_LIST_URL]
